// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"266":"327e628a36810d08ad9a","470":"7700928e03d009ef1d43","700":"c11f730a24522fc215b3","938":"2d3211f3e43e3e793628"}[chunkId] + ".js";
};